module.exports = __webpack_public_path__ + "img/book.1b82395c.png";